const Sucursales = () => {
   return (
      <>
         <div className="section animated fadeIn">
            <div className="bg-latitud animated fadeIn" style={{ "marginBottom": "30px", borderRadius: "8px", backgroundColor: "#039be5", padding: "15px" }}>
               <div className="container section center white-text" style={{ padding: "0" }}>
                  <h5 style={{ margin: 0, fontWeight: '600' }}>
                     <strong>Sucursales</strong>
                  </h5>
               </div>
            </div>

            <div className="row">
               {/* JUJUY */}
               <div className="col s12 m4 l4">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px', minHeight: '230px' }}>
                     <h5 className="light-blue-text text-darken-2" style={{ fontWeight: '600', fontSize: '1.4rem', marginTop: '0' }}>Jujuy</h5>
                     <p className="grey-text text-darken-2" style={{ fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '12px' }}>
                        <strong>Perico:</strong> Av. Urquiza Nº 602. Jujuy, Argentina.
                     </p>
                     <p className="grey-text text-darken-2" style={{ fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
                        <strong>S.S. de Jujuy:</strong> Pedro del Portal 1249 - Barrio 23 de Agosto (Cerca de Ciudad Cultural). Jujuy, Argentina.
                     </p>
                  </div>
               </div>

               {/* SALTA */}
               <div className="col s12 m4 l4">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px', minHeight: '230px' }}>
                     <h5 className="light-blue-text text-darken-2" style={{ fontWeight: '600', fontSize: '1.4rem', marginTop: '0' }}>Salta</h5>
                     <p className="grey-text text-darken-2" style={{ fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '12px' }}>
                        <strong>Salta Capital:</strong> Pueyrredón 1485, local 2. Argentina.
                     </p>
                     <p className="grey-text text-darken-2" style={{ fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
                        <strong>SUMICLI:</strong> Alvarado Nº 973, Salta Capital. Argentina.
                     </p>
                  </div>
               </div>

               {/* OTRAS LOCALIDADES */}
               <div className="col s12 m4 l4">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px', minHeight: '230px' }}>
                     <h5 className="light-blue-text text-darken-2" style={{ fontWeight: '600', fontSize: '1.4rem', marginTop: '0' }}>Interior</h5>
                     <p className="grey-text text-darken-2" style={{ fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '12px' }}>
                        <strong>Las Lajitas:</strong> Av. San Martín Nº 475, Salta. Argentina.
                     </p>
                     <p className="grey-text text-darken-2" style={{ fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
                        <strong>Rosario de Lerma:</strong> Av. 9 de Julio Nº 140 (Oficina 2), Salta. Argentina.
                     </p>
                  </div>
               </div>
            </div>

            {/* MAPA DE UBICACIÓN */}
            <div className="row mt-4">
               <div className="col s12 m12">
                  <div className="card-panel white z-depth-1" style={{ borderRadius: '8px', padding: '10px' }}>
                     <iframe 
                        src="https://www.google.com/maps/d/embed?mid=1ZaYO_fqjh2Up0gGQAC-FZNOi8zEEY_4w&ehbc=2E312F" 
                        width="100%" 
                        height="450px" 
                        style={{ border: 'none', borderRadius: '6px' }}
                        title="Sucursales Latitud Sur"
                     ></iframe>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Sucursales;